import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { selectIsUserLoggedIn } from './auth/store/authSlice';

import { Languages } from './core/enums/languages';
import { useBeforeRender } from './core/hooks/useBeforeRenderer';
import privateRoutes from './routing/privateRoutes';
import usePublicRoutes from './routing/publicRoutes';
import { settingsActions } from './settings/store/settingsSlice';

const App: React.FC = () => {
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(selectIsUserLoggedIn);
  const router = createBrowserRouter([isLoggedIn ? privateRoutes() : {}, ...usePublicRoutes()]);

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') as Languages;
    if (storedLanguage) {
      dispatch(settingsActions.setLanguageTo({ language: storedLanguage }));
    }
  }, []);

  // Workaround for a spurious ResizeObserver error thrown on the window; harmless but noisy in dev.
  useBeforeRender(() => {
    window.addEventListener('error', (e) => {
      if (e) {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) resizeObserverErr.className = 'hide-resize-observer';
        console.error(
          `Resize Observer error occured: https://stackoverflow.com/questions/75774800/how-to-stop-resizeobserver-loop-limit-exceeded-error-from-appearing-in-react-a/76107850#76107850`
        );
        if (resizeObserverErrDiv) resizeObserverErrDiv.className = 'hide-resize-observer';
      }
    });
  }, []);

  return <RouterProvider router={router} />;
};

export default App;
